import { render } from "./StockIndicator.vue?vue&type=template&id=2b390a74"
import script from "./StockIndicator.vue?vue&type=script&lang=js"
export * from "./StockIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__